<template>
        <v-card
          :style="{ 'max-width': tableExpandMaxWidth }"
          class="card-sticky-left"
          flat
        color="transparent">
          <v-card-title>抄表 - M</v-card-title>
          <v-card-text>
            <v-form @submit.prevent="false">
              <v-text-field
                label="Name"
                v-model="name"
              ></v-text-field>
              <v-text-field
                label="Rent"
                v-model="rent"
                type="number"
              ></v-text-field>
              <v-text-field
                label="Elec Price"
                v-model="elecprice"
                type="number"
              ></v-text-field>
              <v-text-field
                label="Mon"
                v-model="mon"
                type="number"
              ></v-text-field>
              <v-text-field
                label="上次度數"
                v-model="last"
                type="number"
              ></v-text-field>
              <v-text-field
                label="本次度數"
                v-model="now"
                type="number"
              ></v-text-field>
              <v-text-field
                label="Diff"
                v-model="diff"
                type="number"
              ></v-text-field>
              <v-text-field
                label="Public last"
                v-model="publast"
                type="number"
              ></v-text-field>
              <v-text-field
                label="Pub now"
                v-model="pubnow"
                type="number"
              ></v-text-field>
              <v-text-field
                label="Room Count"
                v-model="roomcnt"
                type="number"
              ></v-text-field>
              <v-text-field
                label="Total"
                v-model="total"
                readonly
              ></v-text-field>
              <v-btn v-show="false" type="submit"></v-btn>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :disabled="!printer.connected" depressed @click="calcAndPrint()">確定並列印表單</v-btn>
          </v-card-actions>
        </v-card>
</template>

<script>
export default {
  props: [
    "printer",
  ],
  methods: {
    getMonthKey(time, no_merge) {
      // NOTICE, month starting from 0 @ fucking trash javascript
      const t = new Date(time);
      const y = t.getFullYear();
      const m = t.getMonth();
      const d = t.getDate();
      const f = ((d > 27 || (m == 1 && d > 26)) ? 1 : 0);
      return no_merge === true ? {y, m : m + f} : (y * 100 + m + 1 + f);
    },
    getPeriodMonthsAgo(moncnt) {
      const t = this.getMonthKey(new Date(), true);
      //const from = new Date(t.y, t.m, 2).getTime(); // time zone safe ?
      const from = new Date(t.y, t.m, 26).getTime(); // time zone safe ?
      // NOTICE, month starting from 0 @ fucking trash javascript
      for(; moncnt > 0 ; moncnt--, t.m--, t.m ==- 1 && (t.y--, t.m = 11));
      const till = new Date(t.y, t.m, 26).getTime(); // time zone safe ? (Feb 28 days only)
      return {from, till};
    },
    getLastRecordValue(item, lastMon) {
      const t = this.getMonthKey(new Date(), true);
      const recs = this.fullRecords[item.id];
      // NOTICE, month starting from 0 @ fucking trash javascript
      const cmtxt = t.m > 9 ? `${t.m+1}` : `0${t.m+1}`;
      const crec = recs[`${t.y}${cmtxt}`];
      if (!lastMon && crec && crec[0]) {
        return crec[0].value;
      } else {
        // NOTICE, month starting from 0 @ fucking trash javascript
        t.m--;
        if (t.m < 0) {
          t.m = 11;
          t.y--;
        }
        // NOTICE, month starting from 0 @ fucking trash javascript
        const lmtxt = t.m > 8 ? `${t.m+1}` : `0${t.m+1}`;
        const lrec = recs[`${t.y}${lmtxt}`];
        return lrec ? lrec[0].value : -1;
      }
    },
    renderFullRecords(item) {
      const recs = this.fullRecords[item.id];
      const keys = Object.keys(recs).map(i => parseInt(i, 10)).sort().reverse().map(i => `${i}`);
      const out = [];
      keys.forEach(k => {
        out.push({
          name: k.slice(0, -2) + "/" + k.slice(-2),
          data: recs[k],
        });
      });
      return out;
    },
    calcBill(name, rent, elecprice, mon, now, last, diff, pubnow, publast, roomcnt) {
      const cv = document.createElement("canvas");
      const ct = cv.getContext("2d");
      let z = 1, w, h, cw, ch;
      if (this.printer.large) {
        z = 1.536;
        h = cw = cv.width = 384;
        w = ch = cv.height = 590;
        ct.translate(cw, 0);
        ct.rotate(Math.PI/2);
      } else {
        w = cw = cv.width = 384;
        h = ch = cv.height = (pubnow ? 250 : 180);
      }


      ct.fillStyle = "white";
      ct.fillRect(0, 0, w, h);
      
      ct.fillStyle = "black";
      ct.font = `${30*z}px Arial`;
      ct.textAlign = "right";
      ct.fillText(`${mon+1}月`, 380*z, 30*z);
      ct.textAlign = "left";
      ct.fillText(name, 5*z, 30*z, 140*z);
      ct.fillText(`租金 ${rent}`, 155*z, 30*z);
      ct.fillText("電費:", 5*z, 82*z);
      let sub = now - last;
      if (now < last) {
        sub += Math.pow(10, Math.ceil(Math.log10(last)));
      }
      ct.fillText(`${now}-${last}=${sub}度`, 75*z, 65*z);
      const elec = Math.floor(sub * elecprice);
      ct.fillText(`${sub}x${elecprice}元=${elec}元`, 75*z, 100*z);
      let pubelec = 0;
      if (pubnow && publast && !(pubnow === publast && pubnow === 0)) {
        ct.fillText("公電:", 5*z, 152*z);
        let pubsub = pubnow - publast;
        if (pubnow < publast) {
          pubsub += Math.pow(10, Math.ceil(Math.log10(publast)));
        }
        ct.fillText(`${pubnow}-${publast}=${pubsub}度`, 75*z, 135*z);
        pubelec = Math.floor(pubsub * elecprice / roomcnt);
        ct.fillText(`${pubsub}x${elecprice}元/${roomcnt}戶=${pubelec}元`, 75*z, 170*z);
      }
      let y = (205 - (pubnow ? 0 : 70))*z;
      ct.fillText("合計:", 5*z, y);
      ct.fillText(pubnow ? `${rent}+${elec}+${pubelec}` : `${rent}+${elec}`, 75*z, y);
      ct.textAlign = "right";
      const total = rent + elec + pubelec + diff;
      ct.fillText(diff == 0 ? `=${total}` : `-${diff}=${total}`, 380*z, y + 35*z);
      const txt = ct.measureText("21425");
      const x = 380*z - txt.width;
      ct.lineWidth = 2;
      ct.strokeRect(x, y + 10*z, w - x - 2, 30*z);


      const data = ct.getImageData(0, 0, cw, ch).data;
      const bits = [];
      const threshold = 127;

      for (let i = 0; i < data.length; i += 4) {
          // get approx. luma value from RGB
          const luma = data[i] * 0.3 + data[i + 1] * 0.59 + data[i + 2] * 0.11;

          //bits.push(luma < threshold ? 0 : 1); // light => 0 black, 1 white
          bits.push(luma < threshold ? 1 : 0); // dark => 1 black, 0 white
      }

      const print = bits.join("");

      return {
        elec,
        pubelec,
        total,
        print,
      };
    },
    print(print) {
      if (!this.printer.connected) return;
      const p = window.paperang;

      p.sendRawCommand(28, "AQ=="); // set heat density to 255, maybe meaningless ;-P
      p.printBitsString(print);
      p.feedOutPaper();
    },
    retrieveAreas() {
      this.rents = {};
      this.areas = [];
      const res = this.$http.get(`${this.$api}/room`).then(response => {
        response.data.forEach(area => {
          this.areas.push({
            text: area.name,
            value: area.code,
          });
        });
      }).catch(() => false);
      this.areas.push({
        text: "Manual",
        value: "M",
      });
      return res;
    },
    retrieveRents() {
      this.rents = {};
      return this.$http.get(`${this.$api}/rent?area=${this.area}`).then(response => {
        response.data.forEach(rent => {
          this.rents[rent.position] = rent.rent;
        });
      });
    },
    updateMeterRecords() {
      this.retrieveMeterRecords(); // avoid vue default params
    },
    retrieveMeterRecords({from, till} = this.period) {
      window.console.log("meter update");
      if (this.manualMode) {
        this.rooms = ["Manual"];
        window.console.log("manual")
        this.records = [{
          id: "M",
          name: "M",
        }];
        this.headers = [
          {
            text: "",
            value: "dummy",
            width: 1,
            sortable: false,
            filterable: false,
            class: "sticky-detection-dummy",
          },
          {
            text: "房號",
            align: "left",
            value: "name",
            width: "5em",
          },
        ];
      } else
      return this.$http.get(`${this.$api}/meter?area=${this.area}&from=${from}&till=${till}`).then(response => {
        const data = response.body;

        this.rooms = Object.keys(data);
        const idx = this.rooms.indexOf("PUB");
        if (idx == -1) {
          this.rooms.sort();
        } else {
          this.rooms.splice(idx, 1);
          this.rooms.sort();
          this.rooms.unshift("PUB");
        }

        this.records = [];
        this.fullRecords = {};
        this.rooms.forEach(room => {
          this.records.push({
            id: room,
            name: room === "PUB" ? "公電" : room,
          });
          const frecs = this.fullRecords[room] = {};
          data[room].forEach(raw => {
            const k = this.getMonthKey(raw.time);
            if (!frecs[k]) frecs[k] = [];
            frecs[k].push({
              time: raw.time,
              value: raw.value,
            });
          });
        });

        this.headers = [
          {
            text: "",
            value: "dummy",
            width: 1,
            sortable: false,
            filterable: false,
            class: "sticky-detection-dummy",
          },
          {
            text: "房號",
            align: "left",
            value: "name",
            width: "5em",
          },
        ];
        // NOTICE, month starting from 0 @ fucking trash javascript
        const tf = this.getMonthKey(from, true);
        const tt = this.getMonthKey(till, true);
        const kt = tt.y * 100 + tt.m;
        // NOTICE, month starting from 0 @ fucking trash javascript
        // skip last month as it's out of range just for searching range
        for(let m = tf.m, y = tf.y; y * 100 + m > kt ; m--, m ==- 1 && (y--, m = 11)) {
          const k = y * 100 + m + 1;
          const ks = `ym${k}`;
          this.headers.push({
            text: `${y}/${m + 1}`,
            align: "right",
            value: ks,
            id: k,
            ym: {
              y,
              m,
            },
          });
          this.records.forEach(rec => {
            const frecs = this.fullRecords[rec.id][k];
            if (frecs) {
              rec[ks] = frecs[0].value;
            }
          });
        }

        // for writeAll
        this.meter = {};
        this.meterLocked = {};
        this.records.forEach(rec => {
          const k = this.headers[2].id;
          const frecs = this.fullRecords[rec.id][k];
          if (frecs) {
            this.meter[rec.id] = frecs[0].value;
            this.meterLocked[rec.id] = true;
          }
        });
      });
    },
    calcAndPrint() {
      const data = this.calcBill(this.name, Number(this.rent), Number(this.elecprice), Number(this.mon) - 1, Number(this.now), Number(this.last), Number(this.diff), Number(this.pubnow), Number(this.publast), Number(this.roomcnt));
      this.total = data.total;
      this.print(data.print);
    },
    reprint() {
    //reprint(item) {
      //this.print();
      //const data = this.calcBill("自強街 4A", 7600, 5.5, 11, 7291, 7103, 12524, 19100, 19021, 11);
      //const data = this.calcBill("文化北 4E", 7500, 5.5, 11, 35255, 35083, -29, 16629, 16513, 8);
      //const data = this.calcBill("泰山 2B", 9500, 5.5, 11, 9286, 9100, 0);
      //this.print(data.print);
    },
    enterWriteAll() {
      if (this.records.length === 0) return;
      if (Object.keys(this.rents).length === 0) {
        this.retrieveRents().then(() => {
          this.enterWriteAll();
        });
        return;
      }
      this.writeAll = true;
      this.retrieveMeterRecords(this.getPeriodMonthsAgo(2)).then(() => {
        this.expandWriteAll(0);
      });
    },
    exitWriteAll() {
      this.writeAll = false;
      this.expanded = [];
      this.retrieveMeterRecords();
    },
    writeAllDone(item, print) {
      const elecprice = 5.5; // TMP HACK
      const diff = 0; // TMP TEMP QQ

      if (print === true && !this.printer.connected) return;

      const id = item.id;
      const last = this.getLastRecordValue(item, true);
      const now = this.meter[id];

      if (!this.meterLocked[id]) this.putRecord(id, now);

      if (id !== "PUB") {
        let area_name;
        this.areas.forEach(area => {
          if (this.area === area.value) {
            area_name = area.text;
          }
        });
        const name = `${area_name} ${id}`;
        const mon = this.headers[2].ym.m;
        const rent = this.rents[id];
        let pubnow, publast, roomcnt;
        if (this.fullRecords["PUB"]) {
          pubnow = this.meter["PUB"];
          publast = this.getLastRecordValue({ id: "PUB" }, true);
          roomcnt = this.rooms.length - 1;
        }
        const data = this.calcBill(name, rent, elecprice, mon, now, last, diff, pubnow, publast, roomcnt);

        if (this.printer.connected && print !== false) {
          this.print(data.print);
        }
      }

      const next = this.getNextWriteAllIndex();
      if (next == -1) {
        this.exitWriteAll();
      } else {
        this.expandWriteAll(next);
      }
    },
    getNextWriteAllIndex() {
      for (let i = 0; i < this.records.length; i++) {
        if (this.expanded[0].id === this.records[i].id) {
          if (i === this.records.length - 1) { // latest one
            return -1;
          } else {
            return i + 1;
          }
        }
      }
    },
    expandWriteAll(idx) {
      if (typeof idx === "undefined") idx = this.getNextWriteAllIndex();
      const target = this.records[idx];
      this.expanded.splice(0);
      // fold then expend in next tick for the DOM to actually disappear to trigger autofocus
      this.$nextTick(() => {
        this.expanded.push(target);
        // the same, DOM only appear next tick, thus we're able to scroll to it
        this.$nextTick(() => {
          const scroll = document.querySelector(".sticky-monitor-target .v-data-table__wrapper");
          const tot = this.$refs[`ROOM${target.id}`].$el.offsetTop;
          const thh = document.querySelector(".sticky-monitor-target header").offsetHeight;
          const tth = document.querySelector(".sticky-monitor-target th").offsetHeight;
          const ty = tot - thh - tth;
          scroll.scrollTo({ 
            top: ty,
            behavior: "smooth",
          });
        });
      });
    },
    putRecord(room, value) {
      return this.$http.put(`${this.$api}/meter?area=${this.area}&room=${room}&value=${value}`).then(() => { // response => {
      });
    },
    toggleTableRow(item) {
      if (this.expanded[0] && this.expanded[0].id == item.id) {
        this.expanded.splice(0);
      } else {
        this.expanded.splice(0);
        this.expanded.push(item);
      }
    },
    startColumnStickyMonitor() {
      (new IntersectionObserver(entries => {
        this.tableClasses["sticky-happend"] = (entries[0].intersectionRatio === 0);
      }, { threshold: [0,1] })).observe(document.querySelector(".sticky-detection-dummy"));
    },
    confineElementSize() {
      const vh = window.innerHeight;
      const th = document.querySelector(".sticky-monitor-target th");
      const top = th.getBoundingClientRect().top;
      this.tableHeight = vh - top - 1;
      //const vw = window.innerWidth;
      //this.tableExpandMaxWidth = `${vw - 32}px`;
      const table = document.querySelector(".sticky-monitor-target");
      const tw = table.getBoundingClientRect().width;
      this.tableExpandMaxWidth = `${tw - 32}px`;
    },
  },
  created() {
    //this.period = this.getPeriodMonthsAgo(12*2);
    //this.retrieveAreas().then(() => {
      // try to resolve gps here
    //});
  },
  mounted() {
    //this.startColumnStickyMonitor();
    //this.confineElementSize();
  },
  data () {
    return {
      expanded: [],
      headers: [
      ],
      areas: [],
      area: null,
      rooms: [],
      rents: {},
      period: {
        from: 0,
        till: 0,
      },
      tableHeight: "50vh",
      tableExpandMaxWidth: "90vw",
      tableClasses: {
        "sticky-monitor-target": true,
        "sticky-happend": false,
        "confine-max-width": false,
      },
      fullRecords: {
      },
      records: [
      ],
      writeAll: false,
      meterLocked: {
      },
      meter: {
      },
      name: "",
      rent: 0,
      elecprice: 5.5,
      mon: 0,
      now: 0,
      last: 0,
      diff: 0,
      pubnow: 0,
      publast: 0,
      roomcnt: 5,
      total: 0,
    };
  },
  computed: {
    manualMode() {
      return this.area === "M"; 
    },
  },
  watch: {
    writeAll(val) {
      this.tableClasses["confine-max-width"] = val;
    },
  },
}
</script>

<style>
.confine-max-width {
  max-width: 640px;
  margin: 0 auto;
}

th:first-child,
td:first-child {
  padding-right: 0;
}

th:nth-child(2),
td:nth-child(2) {
  padding: 0;
}

th:nth-child(3),
td:nth-child(3) {
  position: -webkit-sticky; /* for Safari */
  position: sticky;
  left: 0;
  padding-left: 8px;
}

th:nth-child(3) {
  z-index: 4 !important;
}

.card-sticky-left {
  position: -webkit-sticky !important; /* for Safari */
  position: sticky !important;
  left: 16px;
}

.sticky-happend th:nth-child(3),
.sticky-happend td:nth-child(3) {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}

.sticky-happend.theme--light td:nth-child(3) {
  background-color: #FFFFFF;
}

.sticky-happend.theme--dark td:nth-child(3) {
  background-color: #424242;
}
</style>
